/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_DealsInputs */

const cs_properties_bulk_transfer_deals = /** @type {(inputs: Properties_Bulk_Transfer_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeřadit i otevřené obchody`)
};

const en_properties_bulk_transfer_deals = /** @type {(inputs: Properties_Bulk_Transfer_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also reassign open deals`)
};

/**
* | output |
* | --- |
* | "Also reassign open deals" |
*
* @param {Properties_Bulk_Transfer_DealsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_deals = /** @type {((inputs?: Properties_Bulk_Transfer_DealsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_DealsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_deals(inputs)
	return cs_properties_bulk_transfer_deals(inputs)
});